goog.provide("shadow.js.shim.module$react_day_picker$DayPickerInput");
goog.provide("module$shadow_js_shim_module$react_day_picker$DayPickerInput");
shadow.js.shim.module$react_day_picker$DayPickerInput = shadow.js.nativeProvides["react-day-picker/DayPickerInput"] = shadow$bridge("react-day-picker/DayPickerInput");
module$shadow_js_shim_module$react_day_picker$DayPickerInput.default = shadow.js.shim.module$react_day_picker$DayPickerInput;
